import { render, staticRenderFns } from "./AuthLayout.vue?vue&type=template&id=4d16c6ab"
import script from "./AuthLayout.vue?vue&type=script&lang=ts"
export * from "./AuthLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports